import { Injectable } from '@angular/core';
import { CustomerMessage } from '@aid/customers/types/classes';

@Injectable()
export class CustomerContractService {
  private message?: CustomerMessage;
  private file?: File;

  getMessage(): CustomerMessage | undefined {
    return this.message;
  }

  getFile(): File | undefined {
    return this.file;
  }

  setMessage(message: CustomerMessage, file: File | undefined) {
    this.message = message;
    this.file = file;
  }
}
